var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.675.5H1.325C.593.5 0 1.093 0 1.825v21.35c0 .732.593 1.325 1.325 1.325h11.494v-9.294H9.691v-3.622h3.128V8.913c0-3.1 1.893-4.788 4.659-4.788 1.324 0 2.463.098 2.795.143v3.24h-1.918c-1.504 0-1.795.715-1.795 1.763v2.313h3.586l-.467 3.622h-3.12V24.5h6.116c.732 0 1.325-.593 1.325-1.325V1.825C24 1.093 23.407.5 22.675.5",
    fill: "#3B5998",
    fillRule: "evenodd"
  })));
}

export default SvgFacebook;